namespace $.$$ {

	export class $shm_hitalama_entergate_app_form extends $.$shm_hitalama_entergate_app_form {

		enter_enabled() {
			return this.secret_key().trim() !== '' && !this.message()
		}

		register_enabled() {
			return this.login().trim() !== '' && !this.message()
		}

		access_apply() {
			return true
		}

		redirect() {
			// This form is already inside the app (also in the Chrome extension).
			// Navigating to / would discard the extension route and auth state.
		}

	}

}
